// extracted by mini-css-extract-plugin
module.exports = {"SubmitBtn":"ReJectetEdit_SubmitBtn__1R_46"};